<template>
  <div>
    <div class="min-h-[calc(100dvh-70px)] pb-20 pt-10 maxXs:pb-20 flex justify-center relative z-0">
      <div class="w-full md:w-[36rem] max-w-[580px] md:m-auto m-0">
        <h1 class="text-blue font-display font-bold text-3xl md:text-[2.5rem] pb-5 px-4 mt-16 md:mt-0 text-center mx-auto">{{ $t('welcome_to_plexytrade') }}</h1>
        <p class="text-gray-900 font-display font-bold text-base leading-7 w-full md:w-[24.5rem] m-auto text-center mb-20">{{ $t('select_demo_live') }}</p>
        <div class="flex gap-4 md:gap-6 justify-center relative">
          <div class="w-20 md:w-[185px] absolute -top-14 md:top-[-100px] ltr:left-8 ltr:md:-left-14 rtl:right-8 rtl:md:-right-14 z-0">
            <img class="hidden md:block" src="../../assets/img/dots.svg" />
            <img class="block md:hidden" src="../../assets/img/dots-mobile.svg" />
          </div>
          <div class="flex items-center md:gap-4 md:px-4 gap-2 px-2 relative z-10">
            <router-link
              class="md:w-[300px] w-36 h-[150px] hover:font-bold hover:border-blue hover:bg-gray-400 bg-white border border-[#DEDFE2] rounded-lg flex justify-center items-center font-display text-gray-dark shadow-ts1 transition-all duration-300 ease-in-out"
              :class="[Language == 'es' ? 'text-xl md:text-3xl ' : ' text-3xl']"
              :to="demoRegisterRoute"
            >
              {{ $t('demo') }}
            </router-link>
            <router-link
              class="md:w-[300px] w-36 h-[150px] hover:font-bold hover:border-blue hover:bg-gray-400 bg-white border border-[#DEDFE2] rounded-lg flex justify-center items-center font-display text-gray-dark font-normal shadow-ts1 transition-all duration-300 ease-in-out"
              :class="[Language == 'es' ? 'text-xl md:text-3xl' : ' text-3xl']"
              :to="liveRegisterRoute"
            >
              {{ $t('live') }}
            </router-link>
          </div>

          <div class="w-20 md:w-[185px] absolute bottom-[-50px] md:bottom-[-100px] ltr:right-6 ltr:md:-right-14 rtl:left-6 rtl:md:-left-14 z-0">
            <img class="hidden md:block" src="../../assets/img/dots.svg" />
            <img class="block md:hidden" src="../../assets/img/dots-mobile.svg" />
          </div>
        </div>
        <div class="mt-16 text-center">
          <p class="text-sm text-gray-dark text-center mb-4">{{ $t('already_have_an_account') }}</p>
          <Button mode="secondary-outlined" customClasses="!w-[200px] bg-transparent">
            <router-link :to="'/' + Language + '/login'">
              {{ $t('login').tTitle() }}
            </router-link>
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/reusableComponents/Button.vue'
import { mapGetters, mapActions } from 'vuex'
import config from '../../config'
export default {
  components: {
    Button,
  },
  data() {
    return {}
  },
  // beforeMount() {
  //   this['logoLoader/set'](true)
  // },
  // created() {
  //   setTimeout(() => {
  //     this['logoLoader/set'](false)
  //   }, 1000)
  // },
  computed: {
    ...mapGetters({
      Language: 'language/code',
    }),
    liveRegisterRoute() {
      return `/${this.Language}/register/live`
    },
    demoRegisterRoute() {
      return `/${this.Language}/register/demo`
    },
  },
  mounted() {
    /*
     * @note
     * `setManualLoader(true)` activates the loader manually.
     * This manual loader does not interfere with the global API call loader
     * (handled through interceptors), making it suitable for non-API-driven pages.
     */
    this['logoLoader/setManualLoader'](true)
    this.$nextTick(() => {
      setTimeout(() => {
        this['logoLoader/setManualLoader'](false)
      }, 1500)
    })
    this.$bus.$emit('ChangeHeadings', this.$t('register').tCapitalizeFirstLetter(), null)
    this.addMeta('canonical', config.URL.cp + this.$route.path)
    this.addMeta('description', this.$t('register_description'))
    this.addMeta('alternate', this.$route.meta.identifierPath)
    this.addMeta('ogtitle', this.$t('register').tCapitalizeFirstLetter() + ' | ' + this.$t('app_name'))
  },
  methods: {
    ...mapActions(['logoLoader/setManualLoader']),
  },
}
</script>
